import { Outlet } from 'react-router-dom'

const ReadBookLayout = () => (
  <div className="read-book-layout">
    <Outlet />
  </div>
)

export default ReadBookLayout
